import 'react-tooltip/dist/react-tooltip.css';
import { Api, fetchData } from './api';
import { AppConfig, config } from './AppConfig';
import { COLA_URL } from 'config/app';
import { createApp } from 'internalLibrary';
import analyticsInstance from 'analyticsInstance';
import se from './localizations/se';

export const App = createApp<Api, typeof se, AppConfig>({
  fetch: fetchData,
  localization: se,
  analyticsInstance,
  config,
  translateError: (app, error) =>
    app.translate(`notification.${error}`, {
      phone: config.phone,
      'phone-no-spaces': config.phone.replaceAll(/\s/g, ''),
    }),
  colaUrl: COLA_URL,
});
